// AdminNavbar.jsx
import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { FaUsers, FaMoneyBillWave, FaFileInvoiceDollar, FaBoxOpen, FaCog } from "react-icons/fa";

const Navbar = styled.header`
  background: #009fb7;
  color: white;
  padding: 20px 40px;
  font-size: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    height: 40px;
  }
`;

const NavItems = styled.div`
  display: flex;
  gap: 30px;
  font-size: 16px;
  font-weight: 500;
  align-items: center;
`;

const NavItem = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

const UserInfo = styled.div`
  text-align: right;
  font-size: 13px;
  line-height: 1.4;

  span {
    display: block;
    font-weight: 500;

    &.email {
      font-size: 14px;
    }

    &.role {
      font-size: 12px;
      opacity: 0.8;
    }
  }
`;

const LogoutButton = styled.button`
  background: white;
  color: #009fb7;
  border: none;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #e2f7fa;
  }
`;

function AdminNavbar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    navigate("/adminpanel/adminlogin");
  };

  const adminUser = JSON.parse(localStorage.getItem("adminUser"));
  const email = adminUser?.userEmail || "Nieznany";
  const role = adminUser?.userRole || "Brak roli";

  return (
    <Navbar>
      <Logo>
        <img src="/Logo2.png" alt="Logo" />
      </Logo>

      <NavItems>
        {role === "SUPERADMIN" && (
          <>
            <NavItem onClick={() => navigate("/adminpanel/dashboard")}>
              <MdDashboard size={18} />
              Panel główny
            </NavItem>

            <NavItem onClick={() => navigate("/adminpanel/admin-users")}>
              <FaUsers size={18} />
              Użytkownicy
            </NavItem>

            <NavItem onClick={() => navigate("/adminpanel/orders")}>
              <FaBoxOpen size={18} />
              Zamówienia
            </NavItem>

            <NavItem onClick={() => navigate("/adminpanel/invoice")}>
              <FaFileInvoiceDollar size={18} />
              Faktury
            </NavItem>

            {/* ✅ NOWA POZYCJA MENU */}
            <NavItem onClick={() => navigate("/adminpanel/settings")}>
              <FaCog size={18} />
              Ustawienia
            </NavItem>
          </>
        )}

        {role === "INFLUENCER" && (
          <NavItem onClick={() => navigate("/adminpanel/revenue")}>
            <FaMoneyBillWave size={18} />
            Przychody
          </NavItem>
        )}
      </NavItems>

      <Right>
        <UserInfo>
          <span className="email">Zalogowano: {email}</span>
          <span className="role">Rola: {role}</span>
        </UserInfo>
        <LogoutButton onClick={handleLogout}>Wyloguj</LogoutButton>
      </Right>
    </Navbar>
  );
}

export default AdminNavbar;
